import { TextField } from '@mui/material';
import VehicleSelector from 'components/new/VehicleSelector';
import DatePicker from 'further-ui/components/DatePicker';
import FormField from 'further-ui/components/FormField';
import { Column } from 'further-ui/components/Layout';
import useEarliestAvailableLedgerDate from 'hooks/lp/data/vehicle/useEarliestAvailableLedgerDate';
import { Controller, useFormContext } from 'react-hook-form';
import { CreateCapitalActionFormValues } from './hooks/useCapitalActionForm';

type Props = {
  vehicle: {
    id: string;
    vehicleName: string;
  };
};

const CapitalActionDetails: React.FC<Props> = ({ vehicle }) => {
  const { control } = useFormContext<CreateCapitalActionFormValues>();
  const earliestAvailableLedgerDate = useEarliestAvailableLedgerDate({
    vehicleId: vehicle.id,
    limitByCapitalActions: true,
  });

  return (
    <Column spacing="lg">
      <FormField label="Vehicle" size="md">
        <VehicleSelector selectedVehicle={vehicle} />
      </FormField>
      <FormField label="Capital action name" size="md">
        <Controller
          name="name"
          control={control}
          render={({ fieldState: { error }, field }) => (
            <TextField
              {...field}
              size="small"
              error={!!error}
              helperText={error?.message}
              fullWidth
            />
          )}
        />
      </FormField>
      <FormField
        label="Capital action date"
        size="md"
        tooltip="This is the accounting date of this capital action."
      >
        <Controller
          name="ledgerDate"
          control={control}
          render={({
            fieldState: { error },
            field: { value, onChange, ...rest },
          }) => (
            <DatePicker
              fullWidth
              error={!!error}
              helperText={error?.message?.toString()}
              value={value}
              onChange={onChange}
              minDate={earliestAvailableLedgerDate?.toUTCDate()}
              {...rest}
            />
          )}
        />
      </FormField>

      <FormField
        label="Capital action due date"
        size="md"
        tooltip="This is the payment due date that will be communicated to LPs if the action is a net capital call."
      >
        <Controller
          name="actionDueDate"
          control={control}
          render={({
            fieldState: { error },
            field: { value, onChange, ...rest },
          }) => (
            <DatePicker
              fullWidth
              error={!!error}
              helperText={error?.message?.toString()}
              value={value}
              onChange={onChange}
              minDate={earliestAvailableLedgerDate?.toUTCDate()}
              {...rest}
            />
          )}
        />
      </FormField>
    </Column>
  );
};

export default CapitalActionDetails;
